/**
 * Reads the Django CSRF token from the csrftoken cookie.
 * Django sets this cookie on any GET request when CSRF protection is active.
 */
export function getCsrfToken() {
    const match = document.cookie.match(/(?:^|;\s*)csrftoken=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : '';
}
